export const themeStyleDark = {
  backgroundColor: "#F4F5FA",
  primaryColor: "#06402b",
  primaryCardColor: "white",
  textColor: "black",
  primaryButtonColor: "#06402b",
  primaryButtonTextColor: "white",
  secondaryButtonColor: "rgb(255,255,255,0.8)",
  primaryColorLight: "#829f95",
};

export const themeStyle = {
  backgroundColor: "#F4F5FA",
  primaryColor: "#06402b",
  primaryCardColor: "white",
  textColor: "black",
  primaryButtonColor: "#06402b",
  primaryButtonTextColor: "black",
  secondaryButtonColor: "rgb(255,255,255,0.8)",
  primaryColorLight: "#829f95",
};
